import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 5000 }
  }

  connect() {
    this.dismissed = false
    this.beforeCacheHandler = this.remove.bind(this)

    document.addEventListener("turbo:before-cache", this.beforeCacheHandler)
    this.timeout = window.setTimeout(() => this.dismiss(), this.dismissAfterValue)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCacheHandler)

    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }
  }

  dismiss() {
    if (this.dismissed) return

    this.dismissed = true
    this.element.classList.add("opacity-0", "-translate-y-2", "pointer-events-none")
    this.element.addEventListener("transitionend", this.beforeCacheHandler, { once: true })
  }

  remove() {
    if (this.timeout) {
      window.clearTimeout(this.timeout)
      this.timeout = null
    }

    if (this.element.isConnected) {
      this.element.remove()
    }
  }
}
